import { useState, useEffect, useCallback } from 'react';

export const useCarousel = (itemsLength, options = {}) => {
  const { loop = true, initialIndex = 0 } = options;

  const [index, setIndex] = useState(initialIndex);

  useEffect(() => {
    setIndex(initialIndex);
  }, [initialIndex]);

  const next = useCallback(() => {
    setIndex((prev) =>
      prev === itemsLength - 1 ? (loop ? 0 : prev) : prev + 1
    );
  }, [itemsLength, loop]);

  const prev = useCallback(() => {
    setIndex((prev) =>
      prev === 0 ? (loop ? itemsLength - 1 : prev) : prev - 1
    );
  }, [itemsLength, loop]);

  return { index, next, prev };
};
